import { CheckCircle } from 'lucide-react';
import { useState } from 'react';

interface AcknowledgeInputProps {
  disabled?: boolean;
  label?: string;
}

const AcknowledgeInput = ({ disabled = false, label = 'Acknowledge' }: AcknowledgeInputProps) => {
  const [acknowledged, setAcknowledged] = useState(false);

  const handleAcknowledge = () => {
    if (!disabled) {
      setAcknowledged(true);
    }
  };

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={handleAcknowledge}
        disabled={disabled || acknowledged}
        className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
          acknowledged
            ? 'bg-green-100 text-green-700 border border-green-300'
            : disabled
              ? 'bg-gray-100 text-gray-400 border border-gray-200 cursor-not-allowed'
              : 'bg-[#F8EFF3] text-[#C0275E] border border-[#C0275E] hover:bg-[#C0275E] hover:text-white'
        }`}
      >
        <CheckCircle size={18} className={acknowledged ? 'text-green-600' : ''} />
        <span>{acknowledged ? 'Acknowledged' : label}</span>
      </button>
      {acknowledged && (
        <p className="text-xs text-green-600 flex items-center gap-1">
          <CheckCircle size={14} />
          You have acknowledged this item
        </p>
      )}
    </div>
  );
};

export default AcknowledgeInput;
